export const stages = [
  {
    stage: 1,
    cefr: "A1",
    questions: [
      {
        id: "A1-Q1",
        type: "multiple_choice",
        skill: "grammar",
        question: "She ____ from Spain.",
        options: ["is", "are", "am", "be"],
        answer: "is"
      },
      {
        id: "A1-Q2",
        type: "multiple_choice",
        skill: "vocabulary",
        question: "What is this?",
        imageUrl: "https://images.unsplash.com/photo-1560806887-1e4cd0b6cbd6?w=300&h=300&fit=crop",
        options: ["banana", "apple", "orange", "grape"],
        answer: "apple"
      },
      {
        id: "A1-Q3",
        type: "multiple_choice",
        skill: "grammar",
        question: "I ____ a student.",
        options: ["am", "is", "are", "be"],
        answer: "am"
      },
      {
        id: "A1-Q4",
        type: "multiple_choice",
        skill: "vocabulary",
        question: "The opposite of 'big' is ____.",
        options: ["small", "tall", "long", "wide"],
        answer: "small"
      },
      {
        id: "A1-Q5",
        type: "multiple_choice",
        skill: "grammar",
        question: "They ____ happy.",
        options: ["is", "am", "are", "be"],
        answer: "are"
      },
      {
        id: "A1-Q6",
        type: "error_correction",
        skill: "grammar",
        question: "Find the error: She have a cat.",
        sentence: "She have a cat.",
        error: "have",
        correction: "has",
        answer: "has"
      },
      {
        id: "A1-Q7",
        type: "multiple_choice",
        skill: "grammar",
        question: "This is ____ book.",
        options: ["a", "an", "the", "some"],
        answer: "a"
      },
      {
        id: "A1-Q8",
        type: "multiple_choice",
        skill: "vocabulary",
        question: "What time is it? It's ____ o'clock.",
        options: ["five", "fives", "fifth", "fived"],
        answer: "five"
      },
      {
        id: "A1-Q9",
        type: "reading_comprehension",
        skill: "reading",
        text: "My name is Anna. I am 25 years old. I live in London. I work in a hospital. I like my job.",
        questions: [
          {
            id: "A1-Q9-1",
            question: "What is her name?",
            options: ["Anna", "Anne", "Amy", "Alice"],
            answer: "Anna"
          },
          {
            id: "A1-Q9-2",
            question: "Where does she work?",
            options: ["school", "office", "hospital", "shop"],
            answer: "hospital"
          },
          {
            id: "A1-Q9-3",
            question: "How old is Anna?",
            options: ["20", "23", "25", "30"],
            answer: "25"
          }
        ]
      },
      {
        id: "A1-Q10",
        type: "multiple_choice",
        skill: "grammar",
        question: "We ____ to school every day.",
        options: ["go", "goes", "going", "went"],
        answer: "go"
      }
    ]
  },
  {
    stage: 2,
    cefr: "A2",
    questions: [
      {
        id: "A2-Q1",
        type: "multiple_choice",
        skill: "grammar",
        question: "I ____ to the cinema yesterday.",
        options: ["go", "went", "gone", "going"],
        answer: "went"
      },
      {
        id: "A2-Q2",
        type: "multiple_choice",
        skill: "grammar",
        question: "She ____ lived here for five years.",
        options: ["has", "have", "is", "was"],
        answer: "has"
      },
      {
        id: "A2-Q3",
        type: "sentence_transformation",
        skill: "grammar",
        question: "Transform to comparative: 'John is tall. Mary is short.'",
        original: "John is tall. Mary is short.",
        answer: "John is taller than Mary"
      },
      {
        id: "A2-Q4",
        type: "multiple_choice",
        skill: "vocabulary",
        question: "The weather is terrible. It's ____ outside.",
        options: ["raining", "rained", "rain", "rains"],
        answer: "raining"
      },
      {
        id: "A2-Q5",
        type: "error_correction",
        skill: "grammar",
        question: "Find the error: I didn't saw him yesterday.",
        sentence: "I didn't saw him yesterday.",
        error: "saw",
        correction: "see",
        answer: "see"
      },
      {
        id: "A2-Q6",
        type: "multiple_choice",
        skill: "grammar",
        question: "If I ____ time, I will help you.",
        options: ["have", "has", "had", "having"],
        answer: "have"
      },
      {
        id: "A2-Q7",
        type: "multiple_choice",
        skill: "vocabulary",
        question: "She is very ____. She always helps people.",
        options: ["kind", "angry", "lazy", "mean"],
        answer: "kind"
      },
      {
        id: "A2-Q8",
        type: "reading_comprehension",
        skill: "reading",
        text: "Last summer, Tom visited Paris for the first time. He stayed there for two weeks. He visited the Eiffel Tower and ate French food. He loved the city and wants to return next year.",
        questions: [
          {
            id: "A2-Q8-1",
            question: "When did Tom visit Paris?",
            options: ["last winter", "last summer", "next year", "last spring"],
            answer: "last summer"
          },
          {
            id: "A2-Q8-2",
            question: "How long did he stay?",
            options: ["one week", "two weeks", "three weeks", "one month"],
            answer: "two weeks"
          },
          {
            id: "A2-Q8-3",
            question: "Did Tom like Paris?",
            options: ["No, he hated it", "Yes, he loved it", "He was bored", "He didn't say"],
            answer: "Yes, he loved it"
          }
        ]
      },
      {
        id: "A2-Q9",
        type: "multiple_choice",
        skill: "grammar",
        question: "I ____ breakfast when the phone rang.",
        options: ["eat", "ate", "was eating", "am eating"],
        answer: "was eating"
      },
      {
        id: "A2-Q10",
        type: "multiple_choice",
        skill: "grammar",
        question: "There ____ many people at the party last night.",
        options: ["was", "were", "is", "are"],
        answer: "were"
      }
    ]
  },
  {
    stage: 3,
    cefr: "B1",
    questions: [
      {
        id: "B1-Q1",
        type: "multiple_choice",
        skill: "grammar",
        question: "If I ____ you, I would accept the job offer.",
        options: ["am", "was", "were", "be"],
        answer: "were"
      },
      {
        id: "B1-Q2",
        type: "multiple_choice",
        skill: "grammar",
        question: "The report ____ by the team next Monday.",
        options: ["will finish", "will be finished", "is finishing", "finishes"],
        answer: "will be finished"
      },
      {
        id: "B1-Q3",
        type: "sentence_transformation",
        skill: "grammar",
        question: "Transform to passive voice:",
        original: "Someone stole my bike yesterday.",
        answer: "My bike was stolen yesterday"
      },
      {
        id: "B1-Q4",
        type: "multiple_choice",
        skill: "vocabulary",
        question: "The company needs to ____ its marketing strategy.",
        options: ["improve", "proof", "approve", "remove"],
        answer: "improve"
      },
      {
        id: "B1-Q5",
        type: "error_correction",
        skill: "grammar",
        question: "Find the error: Despite of the rain, we went hiking.",
        sentence: "Despite of the rain, we went hiking.",
        error: "Despite of",
        correction: "Despite",
        answer: "Despite"
      },
      {
        id: "B1-Q6",
        type: "multiple_choice",
        skill: "grammar",
        question: "She wishes she ____ more time to travel.",
        options: ["has", "have", "had", "having"],
        answer: "had"
      },
      {
        id: "B1-Q7",
        type: "multiple_choice",
        skill: "vocabulary",
        question: "The government announced new measures to ____ unemployment.",
        options: ["reduce", "produce", "induce", "seduce"],
        answer: "reduce"
      },
      {
        id: "B1-Q8",
        type: "reading_comprehension",
        skill: "reading",
        text: "Climate change is one of the most pressing issues of our time. Rising temperatures are causing ice caps to melt, leading to higher sea levels. Scientists warn that if we don't take action soon, the consequences could be catastrophic. Many countries are now investing in renewable energy sources such as solar and wind power to reduce carbon emissions.",
        questions: [
          {
            id: "B1-Q8-1",
            question: "What is causing sea levels to rise?",
            options: ["rain", "melting ice caps", "ocean currents", "wind"],
            answer: "melting ice caps"
          },
          {
            id: "B1-Q8-2",
            question: "What are countries investing in?",
            options: ["fossil fuels", "nuclear power", "renewable energy", "coal mines"],
            answer: "renewable energy"
          },
          {
            id: "B1-Q8-3",
            question: "According to the text, what will happen if no action is taken?",
            options: ["nothing will change", "consequences could be catastrophic", "everything will improve", "temperatures will decrease"],
            answer: "consequences could be catastrophic"
          },
          {
            id: "B1-Q8-4",
            question: "What examples of renewable energy are mentioned?",
            options: ["oil and gas", "solar and wind", "coal and wood", "nuclear and hydro"],
            answer: "solar and wind"
          }
        ]
      },
      {
        id: "B1-Q9",
        type: "multiple_choice",
        skill: "grammar",
        question: "By this time next year, I ____ my degree.",
        options: ["complete", "will complete", "will have completed", "am completing"],
        answer: "will have completed"
      },
      {
        id: "B1-Q10",
        type: "multiple_choice",
        skill: "grammar",
        question: "She suggested ____ to the new restaurant.",
        options: ["to go", "going", "go", "went"],
        answer: "going"
      },
      {
        id: "B1-Q11",
        type: "multiple_choice",
        skill: "vocabulary",
        question: "The negotiations were successful and both parties reached an ____.",
        options: ["argument", "agreement", "disagreement", "arrangement"],
        answer: "agreement"
      },
      {
        id: "B1-Q12",
        type: "error_correction",
        skill: "grammar",
        question: "Find the error: I'm looking forward to see you soon.",
        sentence: "I'm looking forward to see you soon.",
        error: "to see",
        correction: "to seeing",
        answer: "to seeing"
      }
    ]
  },
  {
    stage: 4,
    cefr: "B2",
    questions: [
      {
        id: "B2-Q1",
        type: "multiple_choice",
        skill: "grammar",
        question: "Had I known about the meeting, I ____ attended.",
        options: ["would", "would have", "will", "will have"],
        answer: "would have"
      },
      {
        id: "B2-Q2",
        type: "multiple_choice",
        skill: "vocabulary",
        question: "The politician's speech was full of ____ remarks that offended many people.",
        options: ["controversial", "conventional", "traditional", "professional"],
        answer: "controversial"
      },
      {
        id: "B2-Q3",
        type: "sentence_transformation",
        skill: "grammar",
        question: "Transform using reported speech:",
        original: "'I will call you tomorrow,' she said.",
        answer: "She said she would call me the next day"
      },
      {
        id: "B2-Q4",
        type: "error_correction",
        skill: "grammar",
        question: "Find the error: Neither of the solutions are acceptable.",
        sentence: "Neither of the solutions are acceptable.",
        error: "are",
        correction: "is",
        answer: "is"
      },
      {
        id: "B2-Q5",
        type: "multiple_choice",
        skill: "grammar",
        question: "The project, ____ was completed ahead of schedule, received praise.",
        options: ["that", "which", "who", "what"],
        answer: "which"
      },
      {
        id: "B2-Q6",
        type: "reading_comprehension",
        skill: "reading",
        text: "Artificial intelligence is rapidly transforming the workplace. While some fear that automation will lead to widespread job losses, others argue that AI will create new opportunities and improve productivity. The key lies in adapting our education systems to prepare workers for the jobs of the future. Rather than viewing AI as a threat, we should embrace it as a tool that can augment human capabilities and free us from repetitive tasks, allowing us to focus on creative and strategic work.",
        questions: [
          {
            id: "B2-Q6-1",
            question: "What is the main topic of this passage?",
            options: ["job losses", "education reform", "AI's impact on work", "creative industries"],
            answer: "AI's impact on work"
          },
          {
            id: "B2-Q6-2",
            question: "According to the text, what should we do with AI?",
            options: ["fear it", "ignore it", "embrace it", "reject it"],
            answer: "embrace it"
          },
          {
            id: "B2-Q6-3",
            question: "What does the author suggest AI can free us from?",
            options: ["creative work", "strategic work", "repetitive tasks", "learning"],
            answer: "repetitive tasks"
          }
        ]
      },
      {
        id: "B2-Q7",
        type: "multiple_choice",
        skill: "vocabulary",
        question: "The research findings were ____ and required further investigation.",
        options: ["conclusive", "inconclusive", "exclusive", "inclusive"],
        answer: "inconclusive"
      },
      {
        id: "B2-Q8",
        type: "multiple_choice",
        skill: "grammar",
        question: "Scarcely ____ arrived when the meeting started.",
        options: ["I had", "had I", "I have", "have I"],
        answer: "had I"
      },
      {
        id: "B2-Q9",
        type: "error_correction",
        skill: "grammar",
        question: "Find the error: The data suggests that the hypothesis is correct.",
        sentence: "The data suggests that the hypothesis is correct.",
        error: "suggests",
        correction: "suggest",
        answer: "suggest"
      },
      {
        id: "B2-Q10",
        type: "multiple_choice",
        skill: "grammar",
        question: "I wish I ____ more attention to my finances earlier.",
        options: ["paid", "have paid", "had paid", "pay"],
        answer: "had paid"
      }
    ]
  },
  {
    stage: 5,
    cefr: "C1",
    questions: [
      {
        id: "C1-Q1",
        type: "multiple_choice",
        skill: "vocabulary",
        question: "The company's financial situation was ____, requiring immediate intervention.",
        options: ["precarious", "precious", "precocious", "precipitous"],
        answer: "precarious"
      },
      {
        id: "C1-Q2",
        type: "multiple_choice",
        skill: "grammar",
        question: "Not only ____ the deadline, but they also exceeded expectations.",
        options: ["they met", "did they meet", "they did meet", "met they"],
        answer: "did they meet"
      },
      {
        id: "C1-Q3",
        type: "sentence_transformation",
        skill: "grammar",
        question: "Transform to emphatic structure:",
        original: "The lack of communication caused the problem.",
        answer: "It was the lack of communication that caused the problem"
      },
      {
        id: "C1-Q4",
        type: "error_correction",
        skill: "grammar",
        question: "Find the error: The committee are divided on the issue.",
        sentence: "The committee are divided on the issue.",
        error: "are",
        correction: "is",
        answer: "is"
      },
      {
        id: "C1-Q5",
        type: "multiple_choice",
        skill: "vocabulary",
        question: "His argument was so ____ that even his critics were convinced.",
        options: ["compelling", "compiling", "completing", "complying"],
        answer: "compelling"
      },
      {
        id: "C1-Q6",
        type: "reading_comprehension",
        skill: "reading",
        text: "The notion that economic growth and environmental sustainability are mutually exclusive has been increasingly challenged in recent years. Proponents of 'green growth' argue that technological innovation and policy reforms can decouple economic expansion from environmental degradation. However, critics contend that this optimistic view underestimates the scale of ecological challenges we face. They argue that genuine sustainability requires not just cleaner production methods, but a fundamental rethinking of consumption patterns and economic priorities. The debate reflects deeper tensions between short-term economic imperatives and long-term planetary health.",
        questions: [
          {
            id: "C1-Q6-1",
            question: "What is being challenged according to the text?",
            options: ["technological innovation", "the idea that growth and sustainability can't coexist", "environmental degradation", "consumption patterns"],
            answer: "the idea that growth and sustainability can't coexist"
          },
          {
            id: "C1-Q6-2",
            question: "What do critics believe is necessary for genuine sustainability?",
            options: ["more technology", "policy reforms", "fundamental rethinking of consumption", "faster economic growth"],
            answer: "fundamental rethinking of consumption"
          },
          {
            id: "C1-Q6-3",
            question: "What does 'decouple' mean in this context?",
            options: ["connect", "separate", "combine", "integrate"],
            answer: "separate"
          },
          {
            id: "C1-Q6-4",
            question: "What tension does the debate reflect?",
            options: ["political parties", "different countries", "short-term economic needs vs long-term planetary health", "rich vs poor"],
            answer: "short-term economic needs vs long-term planetary health"
          }
        ]
      },
      {
        id: "C1-Q7",
        type: "multiple_choice",
        skill: "grammar",
        question: "The project, ____ complexity had been underestimated, took twice as long.",
        options: ["which", "whose", "that", "who"],
        answer: "whose"
      },
      {
        id: "C1-Q8",
        type: "multiple_choice",
        skill: "vocabulary",
        question: "The speaker's ____ references to classical literature impressed the audience.",
        options: ["erudite", "erratic", "erroneous", "erosive"],
        answer: "erudite"
      },
      {
        id: "C1-Q9",
        type: "error_correction",
        skill: "grammar",
        question: "Find the error: Having been warned about the risks, the decision was made to proceed.",
        sentence: "Having been warned about the risks, the decision was made to proceed.",
        error: "the decision was made",
        correction: "they decided",
        answer: "they decided"
      },
      {
        id: "C1-Q10",
        type: "multiple_choice",
        skill: "grammar",
        question: "Little ____ that their discovery would revolutionize the field.",
        options: ["they knew", "did they know", "they did know", "knew they"],
        answer: "did they know"
      },
      {
        id: "C1-Q11",
        type: "writing_prompt",
        skill: "writing",
        question: "Write a paragraph (100-150 words) discussing whether technology has made communication better or worse. Support your opinion with examples.",
        minWords: 100,
        maxWords: 150
      }
    ]
  },
  {
    stage: 6,
    cefr: "C2",
    questions: [
      {
        id: "C2-Q1",
        type: "multiple_choice",
        skill: "vocabulary",
        question: "The politician's speech was characterized by ____ that obscured the real issues.",
        options: ["obfuscation", "clarification", "simplification", "verification"],
        answer: "obfuscation"
      },
      {
        id: "C2-Q2",
        type: "multiple_choice",
        skill: "grammar",
        question: "Were it not for your assistance, the project ____.",
        options: ["would fail", "would have failed", "will fail", "fails"],
        answer: "would have failed"
      },
      {
        id: "C2-Q3",
        type: "sentence_transformation",
        skill: "grammar",
        question: "Transform to formal academic style:",
        original: "People think that the economy will get better soon.",
        answer: "It is widely believed that the economy will improve in the near future"
      },
      {
        id: "C2-Q4",
        type: "error_correction",
        skill: "grammar",
        question: "Find the subtle error: The phenomenon which we are witnessing is unprecedented in its scope.",
        sentence: "The phenomenon which we are witnessing is unprecedented in its scope.",
        error: "which",
        correction: "that",
        answer: "that"
      },
      {
        id: "C2-Q5",
        type: "multiple_choice",
        skill: "vocabulary",
        question: "The author's ____ prose style made the complex subject matter accessible.",
        options: ["pellucid", "turbid", "opaque", "murky"],
        answer: "pellucid"
      },
      {
        id: "C2-Q6",
        type: "reading_comprehension",
        skill: "reading",
        text: "The epistemological foundations of modern science rest upon a delicate balance between empirical observation and theoretical abstraction. While the positivist tradition emphasized verifiable facts, contemporary philosophy of science acknowledges the theory-laden nature of observation itself. This paradigmatic shift, catalyzed by Kuhn's seminal work on scientific revolutions, has profound implications for how we understand scientific progress. Rather than a linear accumulation of knowledge, science emerges as a complex dialectic between paradigms, where revolutionary changes fundamentally alter the conceptual framework through which phenomena are interpreted. This view challenges the naive realist assumption that scientific theories simply mirror an objective reality.",
        questions: [
          {
            id: "C2-Q6-1",
            question: "According to the text, what did positivism emphasize?",
            options: ["theoretical abstraction", "verifiable facts", "paradigm shifts", "conceptual frameworks"],
            answer: "verifiable facts"
          },
          {
            id: "C2-Q6-2",
            question: "What does 'theory-laden' imply about observation?",
            options: ["observations are completely objective", "observations are influenced by theoretical assumptions", "observations are impossible", "observations are always wrong"],
            answer: "observations are influenced by theoretical assumptions"
          },
          {
            id: "C2-Q6-3",
            question: "How is scientific progress characterized in the text?",
            options: ["linear accumulation", "complex dialectic between paradigms", "random chance", "divine inspiration"],
            answer: "complex dialectic between paradigms"
          },
          {
            id: "C2-Q6-4",
            question: "What assumption does this view challenge?",
            options: ["science is useful", "science exists", "theories mirror objective reality", "observations can be made"],
            answer: "theories mirror objective reality"
          }
        ]
      },
      {
        id: "C2-Q7",
        type: "multiple_choice",
        skill: "grammar",
        question: "So profound ____ the implications of the discovery that it took years to fully appreciate.",
        options: ["was", "were", "is", "are"],
        answer: "were"
      },
      {
        id: "C2-Q8",
        type: "multiple_choice",
        skill: "vocabulary",
        question: "The lawyer's ____ argument failed to convince the jury despite its apparent sophistication.",
        options: ["specious", "species", "spacious", "precious"],
        answer: "specious"
      },
      {
        id: "C2-Q9",
        type: "error_correction",
        skill: "grammar",
        question: "Find the error: The extent to which the policy has been successful remains to be seen.",
        sentence: "The extent to which the policy has been successful remains to be seen.",
        error: "none",
        correction: "none",
        answer: "none"
      },
      {
        id: "C2-Q10",
        type: "multiple_choice",
        skill: "grammar",
        question: "The manuscript, ____ authenticity had long been disputed, was finally verified.",
        options: ["which", "whose", "that", "who"],
        answer: "whose"
      },
      {
        id: "C2-Q11",
        type: "writing_prompt",
        skill: "writing",
        question: "Write an analytical paragraph (150-200 words) evaluating the extent to which social media has influenced political discourse in democratic societies. Consider both benefits and drawbacks.",
        minWords: 150,
        maxWords: 200
      }
    ]
  }
];

export const cefrDescriptors = {
  "Pre-A1": {
    level: "Pre-A1",
    description: "Can understand and use very basic phrases. Needs significant language support.",
    ielts: "< 2.0",
    toefl: "< 32"
  },
  "A1": {
    level: "A1 - Beginner",
    description: "Can understand and use familiar everyday expressions and very basic phrases. Can introduce themselves and ask basic questions about personal details.",
    ielts: "2.0 - 3.0",
    toefl: "32 - 34"
  },
  "A2": {
    level: "A2 - Elementary",
    description: "Can understand sentences and frequently used expressions. Can communicate in simple routine tasks requiring direct exchange of information.",
    ielts: "3.0 - 4.0",
    toefl: "35 - 45"
  },
  "B1": {
    level: "B1 - Intermediate",
    description: "Can understand main points of clear standard input. Can deal with most situations while traveling. Can produce simple connected text on familiar topics.",
    ielts: "4.0 - 5.0",
    toefl: "46 - 59"
  },
  "B2": {
    level: "B2 - Upper Intermediate",
    description: "Can understand the main ideas of complex text. Can interact with fluency and spontaneity. Can produce clear, detailed text on various subjects.",
    ielts: "6.0 - 6.5",
    toefl: "60 - 78"
  },
  "C1": {
    level: "C1 - Advanced",
    description: "Can understand a wide range of demanding texts. Can express ideas fluently without obvious searching for expressions. Can use language flexibly for social, academic, and professional purposes.",
    ielts: "7.0 - 8.0",
    toefl: "79 - 95"
  },
  "C2": {
    level: "C2 - Proficiency",
    description: "Can understand virtually everything with ease. Can express themselves spontaneously, fluently, and precisely. Can differentiate finer shades of meaning in complex situations.",
    ielts: "8.5 - 9.0",
    toefl: "96 - 120"
  }
};
